import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Grid, Row, Col, Button, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import * as insightSetCreators from '../../actions/insightSets/insightSetCreators';
import { getCurrentOrganisationInsightSets } from '../../actions/organisations/insightSetCreators';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import InsightSetSidebar from './InsightSetSidebar';
import InsightSetTabSidebar from './InsightSetTabSidebar';
import SearchIcon from '../../images/search-icon.png';
import LoadingSpinner from '../../components/LoadingSpinner';
import HelpWrapper from '../../components/HelpWrapper';
import { getSetting } from '../../actions/settings/settingsCreators';

class InsightSets extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentWillMount() {
    this.props.checkLoggedInUserIsGlobalAdmin();
  }

  componentDidMount() {
    const { getSetting } = this.props;

    // get current insight set
    const insightSetId = this.props.params.insightSetId;
    new Promise((resolve, reject) => {
      // url: /insightsets
      if (!insightSetId) {
        this.props.clearCurrentInsightSet();
        resolve(true);
      }

      // url: /insightsets/new
      if (insightSetId === 'new') {
        this.props.clearCurrentInsightSet();
        this.props.getInsightSetSettings();
        resolve(true);
      }

      this.props
        .updateCurrentInsightSet(parseInt(insightSetId, 10))
        .then(() => {
          resolve(true);
        });
    }).then(() => {
      this.setState({ loading: false });
    });

    getSetting('insightSetHelpPdf');
    getSetting('insightSetHelpVideo');
  }

  componentWillReceiveProps(nextProps) {
    // Update Insight Sets if currentOrganisation has changed
    const currentOrg = this.props.currentOrganisation;
    const newCurrentOrg = nextProps.currentOrganisation;
    const newContext = nextProps.params.context;
    if (currentOrg.id !== newCurrentOrg.id && newContext !== 'global') {
      this.props.getInsightSets(newCurrentOrg.id);
      // update url back to /insightsets
      this.props.router.push(`/insight-sets/${newContext}`);
    }

    const oldURLParams = this.props.params.insightSetId;
    const newURLParams = nextProps.params.insightSetId;
    if (newURLParams === 'new' && oldURLParams !== 'new') {
      this.props.getInsightSetSettings();
    }

    const currentInsightSetId = this.props.params.insightSetId;
    const newCurrentInsightSetId = nextProps.params.insightSetId;

    if (newCurrentInsightSetId !== currentInsightSetId) {
      this.handleInsightSetIdUpdate(newCurrentInsightSetId);
    }
  }

  handleInsightSetIdUpdate = newInsightSetId => {
    // url: /insight-sets
    if (!newInsightSetId) {
      this.props.clearCurrentInsightSet();
      return;
    }

    // url: /insight-sets/new
    if (newInsightSetId === 'new') {
      this.props.clearCurrentInsightSet();
      return;
    }

    // url: /insight-sets/10
    this.props.updateCurrentInsightSet(parseInt(newInsightSetId, 10));
  };

  render() {
    const { settings } = this.props;
    const currentComponent = this.props.children
      ? this.props.children.type.displayName
      : '';
    return (
      <Grid fluid>
        <Helmet>
          <title>Manage Insight Sets | Campaign Targeter</title>
        </Helmet>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            <InsightSetSidebar {...this.props} items={this.props.insightSets} />
          </Col>
          <Col sm={9} className="insights-set-maincontent">
            <div>
              <Row>
                <HelpWrapper
                  pdfUrl={
                    settings && settings.insightSetHelpPdf
                      ? settings.insightSetHelpPdf.value
                      : undefined
                  }
                  videoUrl={
                    settings && settings.insightSetHelpVideo
                      ? settings.insightSetHelpVideo.value
                      : undefined
                  }
                  extraClass={this.props.children ? 'child-page-present' : ''}
                />
              </Row>
              {!this.props.children && (
                <div>
                  <Link to={`/insight-sets/new`} className="well-300">
                    <Image src={SearchIcon} />
                    <Button bsStyle="primary">Create new Insight Set</Button>
                  </Link>
                </div>
              )}
            </div>
            {this.props.children && (
              <Row className="insights-details">
                <Col sm={4} lg={3} className="insights-sidebar">
                  <InsightSetTabSidebar
                    activeTab={currentComponent}
                    insightSetId={this.props.params.insightSetId}
                    shareWithAllIndustries={
                      this.props.currentInsightSet.shareWithAllIndustries
                    }
                  />
                </Col>
                <Col sm={8} lg={9} className="insights-maincontent">
                  {this.state.loading && <LoadingSpinner />}

                  {!this.state.loading &&
                    React.cloneElement(this.props.children, { ...this.props })}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentOrganisation: state.currentOrganisation,
    currentLocation: state.currentLocation,
    insightSets: state.insightSets,
    currentInsightSet: state.currentInsightSet,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...insightSetCreators,
      getCurrentOrganisationInsightSets,
      checkLoggedInUserIsGlobalAdmin,
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(InsightSets);



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSets.js